import { render, staticRenderFns } from "./MeetingsMenu.vue?vue&type=template&id=2f6f0b5a&"
import script from "./MeetingsMenu.vue?vue&type=script&lang=js&"
export * from "./MeetingsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports